/**
 * Tokens du Design System V2 (TEC-3051) — valeurs EXACTES issues du handoff Claude Design
 * (`colors_and_type.css` + bloc tokens de la maquette « Tableau de bord de mission »).
 *
 * Exposés en objet TS pour être consommés via MUI `sx`/`styled` (convention du repo), sans
 * introduire de CSS brute. Ne pas confondre avec `theme.palette` (rampe historique) : la V2
 * utilise une rampe de gris froids à teinte violette + des tons sémantiques propres.
 */
export const dsV2 = {
  color: {
    noir: '#212121',
    blanc: '#FFFFFF',
    // Surfaces & fonds
    bg: '#F9F9FB',
    surface: '#FFFFFF',
    surface2: '#F2F2F5',
    border: '#E4E4EA',
    borderLight: '#EEEEF2',
    // Texte (t1 fort → t4 discret)
    t1: '#212121',
    t2: '#4A4A5A',
    t3: '#6B6B7E',
    t4: '#9C9CAC',
    // Rampe de gris froids (colors_and_type.css)
    g50: '#F9F9FB',
    g100: '#F2F2F5',
    g200: '#E4E4EA',
    g300: '#C8C8D4',
    g400: '#9898A8',
    g500: '#6B6B7E',
    g600: '#4A4A5A',
    g700: '#333342',
    g800: '#212130',
    // Bleu Vif (primaire)
    bleu: '#1561EB',
    bleuDark: '#174FB5',
    bleuLight: '#6B9EFF',
    bleuDim: 'rgba(21,97,235,0.08)',
    bleuMid: 'rgba(21,97,235,0.15)',
    bleuBrd: 'rgba(21,97,235,0.22)',
    bleuDoux: '#DFEAFF',
    bleuDouxLight: '#EEF4FF',
    // Vert (succès / marge / présent)
    vert: '#4D7236',
    vertDim: 'rgba(77,114,54,0.10)',
    vertBrd: 'rgba(77,114,54,0.24)',
    vertLight: '#EEF5EB',
    // Rouge (erreur / expiré / danger)
    rouge: '#FF3328',
    rougeDark: '#CC1E16',
    rougeDim: 'rgba(255,51,40,0.07)',
    rougeBrd: 'rgba(255,51,40,0.22)',
    rougeLight: '#FFF0EF',
    rougeBorder: '#FFCDD0',
    // Amber (warning / fallback société)
    amber: '#C17A00',
    amberDim: 'rgba(232,160,0,0.10)',
    amberBrd: 'rgba(232,160,0,0.26)',
    amberLight: '#FFF8E1',
    amberText: '#C17A00',
    // Texte « warning » foncé (sur fond amberDim) + surface « fallback société » (washes légers)
    amberDark: '#8A5500',
    amberSoft: 'rgba(232,160,0,0.06)',
    amberSoftBrd: 'rgba(232,160,0,0.14)',
    // Accents
    violet: '#5B5ED4',
    violetDim: 'rgba(194,197,249,0.22)',
    violetLight: '#EFEDFB',
    rose: '#F9A3BA',
    solaire: '#C1C74E',
    solaireText: '#7A7E1A',
    beigeDim: '#F0F0F4',
  },
  radius: {
    xs: '6px', // chips/inputs/petits boutons (r-xs)
    sm: '9px', // inputs, petites cartes (r-sm)
    md: '10px', // boutons, cartes (r2)
    lg: '14px', // cartes, KPI, hero (r / r3)
    card: '16px',
    pill: '20px', // chips statut / stage pills (r-pill)
    round: '999px',
  },
  shadow: {
    sm: '0 1px 2px rgba(33,33,33,0.05),0 3px 12px rgba(33,33,33,0.04)',
    hover: '0 2px 8px rgba(33,33,33,0.08),0 6px 20px rgba(33,33,33,0.06)',
    lg: '0 6px 28px rgba(33,33,33,0.11),0 2px 6px rgba(33,33,33,0.05)',
    primary: '0 2px 10px rgba(31,102,235,.28)',
    panel: '-8px 0 32px rgba(33,33,33,.12)',
  },
  space: { s1: 4, s2: 8, s3: 12, s4: 16, s5: 20, s6: 24, s8: 32 },
  font: {
    serif: "'Instrument Serif Regular', 'Instrument Serif', Georgia, serif",
    sans: "'Poppins Regular', 'Poppins', 'Helvetica Neue', Arial, sans-serif",
    sansMedium: "'Poppins Medium', 'Poppins', sans-serif",
    sansSemiBold: "'Poppins SemiBold', 'Poppins', sans-serif",
    sansBold: "'Poppins Bold', 'Poppins', sans-serif",
  },
} as const;
